import Pannel from './Pannel.jsx';

export default Pannel;


// WEBPACK FOOTER //
// ./src/components/pages/Create/universe/customTreeTable/pannel/index.jsx